/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GenerateChannelsResultViewModel } from "../types/GenerateChannelsResultViewModel.ts";

export const generateChannelsResultViewModelSchema = z.object({
  success: z.optional(z.boolean()),
  message: z.string().nullish(),
  channels: z.array(z.string()).nullish(),
}) as unknown as ToZod<GenerateChannelsResultViewModel>;
